import { connect } from "react-redux";
import FollowUp from "./followUp";
import { bindActionCreators } from "redux";
import { getFollowUpListing } from "services/redux/sales/followUpListing/action";

const mapStateToProps = (state) => ({
  followUpList: state.followUpListReducer.followUpList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getFollowUpListing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FollowUp);
